import { render, staticRenderFns } from "./AccessForbidden403.vue?vue&type=template&id=5501fb83&"
import script from "./AccessForbidden403.vue?vue&type=script&lang=js&"
export * from "./AccessForbidden403.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports